module.exports = __webpack_public_path__ + "static/media/moto_izquierda.340d73ab.png";